import { FinancingData } from '@domain/Financing/FinancingData'

export const PANELS_RESIZED_REASON = {
  REDUCED_OFFER_BY_MISSING_NEARBY_CUPS_DATA:
    'reduced-offer-by-missing-nearby-cups-data',
  REDUCED_OFFER_BY_INSUFFICIENT_NEARBY_CUPS:
    'reduced-offer-by-insufficient-nearby-cups',
  REDUCED_OFFER_BY_PMA_RESTRICTIONS: 'reduced-offer-by-pma-restrictions',
}

export const TYPE_OF_OFFER = {
  STANDARD: 'standard',
  RECOMMENDED: 'recommended',
  CUSTOM: 'custom',
}

export const GROSS_MARGIN_LEVEL = {
  PRICE_OK: 'PRICE_OK',
  PRICE_EQUALS_UP: 'PRICE_EQUALS_UP',
  PRICE_BELOW_UP: 'PRICE_BELOW_UP',
  PRICE_LOW_NEEDS_TL_APPROVAL: 'PRICE_LOW_NEEDS_TL_APPROVAL',
}

// Paga y señal por defecto (€). De momento es constante; en el futuro vendrá
// configurada desde el backoffice (igual para todos los clientes).
export const DEFAULT_DEPOSIT = 200

export function Offer({
  type,
  id,
  // Consumo anual con el que solarproduct ha calculado la oferta (p. ej. el mínimo de
  // Tarifa Justa). Solo lo trae la oferta simulada; en las demás viene en Installation.
  consumption = null,
  panels,
  shadedPanels,
  optimalPanels,
  capex,
  subsidy,
  totalSubsidy,
  subsidies,
  allowedSubsidy = true,
  installationValue,
  installationValueWithDiscount,
  totalValue,
  assets,
  initialInvestment,
  deposit = DEFAULT_DEPOSIT,
  installationTax,
  grossCustomerSavingsWithTaxes,
  monthlyGrossCustomerSavingsWithTaxes,
  futureGrossCustomerSavingsWithTaxes = null,
  savingsFormat,
  offerResizeInfo,
  newInvoice,
  financingData = {},
  savingsInYears = {},
  payback = {},
  paybackWithSubsidy = {},
  sharedCups = [],
  maxPanelsWithPma,
  monthlySurplusSavings,
  yearlySurplusSavings,
  production,
  fee,
  discounts,
  energyEfficiencyCertificatePriceWithTaxes,
  energyEfficiencyCertificateQuantity,
  promotions = [],
  onlySolar = false,
  newGrid,
  surplus,
  eligibleTj0Promotions,
  grossMargin = null,
  upPrice = null,
  upPriceWithTax = null,
  upPriceBreakdown = null,
  canOffer = true,
}) {
  function getFinancingData(financingData) {
    return Object.keys(financingData).length ? FinancingData(financingData) : {}
  }

  function getDiscounts() {
    let result = {
      battery: 0,
      certificate: 0,
      evCharger: 0,
      panels: 0,
    }
    if (discounts && Object.keys(discounts).length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { installation, ...discountsWithoutInstallation } = discounts
      result = { ...result, ...discountsWithoutInstallation }
    }
    return result
  }

  function getTotalValueWithoutDiscounts() {
    const totalDiscounts = Object.values(getDiscounts()).reduce(
      (sum, discount) => sum + discount,
      0
    )

    return Number(totalValue) + Number(totalDiscounts)
  }
  return Object.freeze({
    type,
    id,
    consumption,
    panels,
    shadedPanels,
    optimalPanels,
    capex,
    subsidy,
    totalSubsidy,
    subsidies,
    allowedSubsidy,
    installationTax,
    installationValue,
    installationValueWithDiscount,
    totalValue,
    totalValueWithoutDiscounts: getTotalValueWithoutDiscounts(),
    assets,
    initialInvestment,
    deposit,
    grossCustomerSavingsWithTaxes,
    monthlyGrossCustomerSavingsWithTaxes,
    futureGrossCustomerSavingsWithTaxes,
    newInvoice,
    savingsFormat,
    offerResizeInfo: PANELS_RESIZED_REASON[offerResizeInfo] || null,
    financingData: getFinancingData(financingData),
    savingsInYears,
    payback,
    paybackWithSubsidy,
    sharedCups,
    maxPanelsWithPma,
    monthlySurplusSavings,
    yearlySurplusSavings,
    production,
    fee,
    discounts: getDiscounts(),
    energyEfficiencyCertificatePriceWithTaxes,
    energyEfficiencyCertificateQuantity,
    promotions,
    onlySolar,
    newGrid,
    surplus,
    eligibleTj0Promotions: eligibleTj0Promotions || [],
    grossMargin,
    upPrice,
    upPriceWithTax,
    upPriceBreakdown,
    canOffer,
  })
}
